if (!customElements.get('top-replacement-parts')) {
  class TopReplacementParts extends HTMLElement {
    connectedCallback() {
      this._track = this.querySelector('.trp-track');
      this._prevBtn = this.querySelector('.trp-prev');
      this._nextBtn = this.querySelector('.trp-next');
      if (!this._track) return;

      if (this._prevBtn) {
        this._prevBtn.addEventListener('click', () => {
          this._track.scrollBy({ left: -this._cardStep(), behavior: 'smooth' });
        });
      }

      if (this._nextBtn) {
        this._nextBtn.addEventListener('click', () => {
          this._track.scrollBy({ left: this._cardStep(), behavior: 'smooth' });
        });
      }

      this._track.addEventListener('scroll', () => this._updateNav(), { passive: true });
      setTimeout(() => this._updateNav(), 100);
      window.addEventListener('resize', () => this._updateNav());
      this._initCartButtons();
    }

    _initCartButtons() {
      this.querySelectorAll('.trp-card__cart-btn[data-variant-id]').forEach(btn => {
        btn.addEventListener('click', async (e) => {
          e.preventDefault();
          e.stopPropagation();
          const variantId = btn.dataset.variantId;
          if (!variantId || btn.classList.contains('is-adding')) return;
          btn.classList.add('is-adding');
          try {
            const addRes = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
            });
            if (!addRes.ok) throw new Error('ATC failed');

            // Refresh drawer HTML + badge, then open the drawer
            const cart = await (window.theme?.refreshCartDrawer?.({ open: true })
              ?? fetch('/cart.js').then(r => r.json()));

            if (window.LakiEvents?.emit) {
              window.LakiEvents.emit(window.LakiEvents.EVENTS.CART_ADD, { count: cart?.item_count });
            }
            btn.classList.remove('is-adding');
            btn.classList.add('is-added');
            setTimeout(() => btn.classList.remove('is-added'), 2000);
          } catch {
            btn.classList.remove('is-adding');
          }
        });
      });
    }

    _cardStep() {
      const card = this._track.querySelector('.trp-card');
      if (!card) return 220;
      const gap = parseFloat(getComputedStyle(this._track).gap) || 16;
      return card.getBoundingClientRect().width + gap;
    }

    _updateNav() {
      const t = this._track;
      if (!t) return;
      const atStart = t.scrollLeft <= 2;
      const atEnd = t.scrollLeft >= t.scrollWidth - t.clientWidth - 4;
      // aria-hidden alone doesn't remove a button from the keyboard tab
      // order, so a hidden-but-still-focusable nav button is a real a11y
      // bug (Lighthouse: "aria-hidden elements contain focusable
      // descendants") — tabindex has to be toggled alongside it.
      if (this._prevBtn) {
        this._prevBtn.setAttribute('aria-hidden', atStart ? 'true' : 'false');
        this._prevBtn.tabIndex = atStart ? -1 : 0;
      }
      if (this._nextBtn) {
        this._nextBtn.setAttribute('aria-hidden', atEnd ? 'true' : 'false');
        this._nextBtn.tabIndex = atEnd ? -1 : 0;
      }
    }
  }

  customElements.define('top-replacement-parts', TopReplacementParts);
}
